import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  input,
} from '@angular/core';

import { IconComponent, MessageBarService, ResolvableModal } from '@softline/ui-core';
import { NfcReaderStore, SOFTLINE_FEATURE_NFC_READER } from '@softline/application';
import { skip } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Store } from '@softline/core';
import { CartItem } from '@softapps/wws/pos-core';
import { ProductDescriptionHeaderComponent } from '../../components/product-description-header/product-description-header.component';

@Component({
  selector: 'soft-cashier-age-approval-modal',
  imports: [IconComponent, ProductDescriptionHeaderComponent],
  templateUrl: './cashier-age-approval-modal.component.html',
  styleUrl: './cashier-age-approval-modal.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [],
})
export class CashierAgeApprovalModalComponent extends ResolvableModal<boolean> {
  readonly #store = inject(Store);
  readonly #messageBarService = inject(MessageBarService);
  private destroyRef = inject(DestroyRef);

  readonly cartItem = input.required<CartItem>();
  readonly age = input.required<number>();

  constructor() {
    super();

    this.#store
      .observe(SOFTLINE_FEATURE_NFC_READER, NfcReaderStore.getters.latest)
      .pipe(skip(1), takeUntilDestroyed(this.destroyRef))
      .subscribe(async (value) => {
        if (value?.type === 'read' && value?.serialNumber) {
          this.resolve(true);
        } else {
          const errorMessage =
            value?.type === 'error'
              ? value?.error || 'Fehler beim Lesen des Chips!'
              : 'Fehler beim Lesen des Chips!';
          this.#messageBarService.error(errorMessage);
        }
      });
  }
}
